export enum LocationPickerLayout {
  MultiCustomer = 'multi-customer',
  MultiLocation = 'multi-location',
  MultiArea = 'single-location',
  SingleArea = 'single-area',
  Unknown = 'unknown'
}
